const message = {
    accept_order: "Accept Order",
    account_group: "Account Group",
    add_to_shipment: "Add To Shipment",
    address1: "Address1",
    address2: "Address2",
    address3: "Address3",
    address4: "Address4",
    address5: "Address5",
    address: "Address",
    all_business_segment: "All Product Category",
    all_commodity_group: "All Commodity Group",
    all_company: "All Company",
    all_distribution: "All Distribution",
    all_location: "All Location",
    all_plant: "All Plant",
    all_purchase_organization: "All Purchase Organization",
    all_sales_organization: "All Sales Organization",
    all_allow_sto: "Allow STO",
    all_allow_spo: "Allow SPO",
    allow_sto: "Allow STO",
    allow_spo: "Allow SPO",
    alternative_uom: "Alternative UOM",
    amount: "Amount",
    appointment_date: "Appointment Date",
    appointment_matrix: "Appointment Matrix",
    appointment_schedule: "Schedule",
    appointment_status: "Appointment Status",
    appointment_status_date: "Warehouse Approval Date",
    appointment_status_remarks: "Appointment Status Remarks",
    appointment_time:"Appointment Time",
    approval: "Approval",
    approval_by: "Approval By",
    approval_confirmation: "Approval Confirmation",
    approval_date: "Approval Date",
    approval_matrix: "Approval Matrix",
    approve: "Approve",
    assign_customer_vendor: "Assign to Customer/Vendor",
    assign_reason: "Assign Reason",
    assign_to_driver: "Assign to Driver",
    assign_to_transporter: "Assign to Transporter",
    auto_reject_date: "Auto Reject Date",
    back: "Back",
    base_freight_cost: "Base Freight Cost",
    base_freight_per: "Base Freight Per",
    base_freight_uom: "Base Freight UOM",
    base_uom:"Base UOM",
    blacklist_reason:"Blacklist & Reason",
    blocked: "Blocked",
    cancel_order: "Cancel",
    cancel_shipment: "Cancel",
    cancelled: "Cancelled",
    capacity:"Capacity",
    capacity_kg:"Capacity (KG)",
    category: "Category",
    change_stuffing_date:"Change Stuffing Date",
    charge_oa_company: "Charge OA Company",
    city: "City",
    clear: "Unfilter",
    close:"Close",
    code: "Code",
    collective_ln: "Collective LN",
    commodity: "Commodity",
    commodity_group: "Commodity Group",
    company: "Company",
    company_code: "Company Code",
    completed_date: "Completed Date",
    condition_type: "Condition Type",
    condition_category: "Condition Category",
    contact_person :"Contact Person",
    convert_shipment: "Convert Shipment",
    country: "Country",
    create: "Create",
    create_type: "Type",
    create_appointment: "Create Appointment",
    created_by : "Created By",
    created_date: "Created Date",
    credit_group: "Credit Group",
    credit_group_desc: "Credit Group Desc.",
    currency: "Currency",
    current_stuffing_date: "Current Stuffing Date",
    customer: "Customer",
    customer_vendor: "Customer/Vendor",
    customer_vendor_notes: "Customer/Vendor Notes",
    date_of_birth:"Date of Birth",
    delete: "Delete",
    deleted_by: "Deleted By",
    deleted_date: "Deleted Date",
    delivery_address: "Delivery Address",
    delivery_no: "Delivery No.",
    delivery_order_no: "Delivery Order No.",
    delivery_qty: "Delivery Qty",
    denominator: "Denominator",
    department: "Department",
    description: "Description",
    destination: "Destination",
    discharge_port: "Discharge Port",
    dispatch_status: "Transporter Accept Status",
    dispatch_status_reason: "Transporter Status Reason",
    distribution: "Distribution",
    distribution_channel: "Distribution Channel",
    division: "Division",
    do_bl_no: "DO BL No",
    doc_date: "Doc. Date",
    doc_type: "Document Type",
    document_date: "Document Date",
    document_no: "Doc. No",
    document_type: "Document Type",
    driver: "Driver",
    driver_name:"Driver Name",
    edit: "Edit",
    edit_appointment: "Edit Appointment",
    edit_order: "Edit Order",
    edit_sap_order: "Edit SAP Order",
    edit_shipment: "Edit Shipment",
    edited_by: "Edited By",
    edited_date: "Edited Date",
    email: "Email",
    emp_number: "Employee Number",
    epod: "ePOD",
    estate:"Estate",
    exclude_loading_cost: "Exclude Loading Cost",
    exclude_unloading_cost: "Exclude Unloading Cost",
    factory: "Factory",
    fax:"Fax",
    freight: "Freight",
    freight_best_price: "Best Price Total Cost",
    freight_best_price_uom: "Best Price/KG",
    freight_cost: "Freight Cost (Per UOM)", //"Biaya Pengiriman (Per UOM)",
    freight_cost_base: "Freight Cost",
    freight_cost_master: "Freight Cost Master",
    freight_cost_per: "Freight Per",
    freight_cost_suggested: "Biaya Pengiriman yang Dipilih",
    freight_cost_uom: "Freight UOM",
    freight_date: "Freight Cost Date",
    freight_different_per_uom: "Different Per KG",
    freight_different_percentage: "Percentage Different",
    freight_kg: "RP/KG (Based Order Qty)",
    freight_kg_based: "RP/KG (Based Capacity)",
    freight_master: "Freight Master",
    freight_per: "Per UOM",
    freight_total: "Freight Total",
    freight_total_cost: "Est. Freight Total Cost", //Est. Total Biaya Pengiriman
    freight_total_cost_user_not: "Freight Total Cost", // "Total Biaya Pengiriman",
    freight_total_different: "Total Different",
    freight_value: "Freight Value",
    full_name: "Full Name",
    generate_qr: "Generate QR",
    group: "Group",
    has_order: "Order",
    has_shipment: "Shipment",
    has_tracking: "Has Tracking",
    header_details:"Header & Details",
    hello: "Hello",
    history_log: "History",
    inactive_account: "This account has been inactive for more than 90 days.",
    incoterm2: "Incoterm2",
    incoterm: "Incoterm",
    incoterm_name: "Incoterm",
    info1: "Info1",
    info2: "Info2",
    invalid: "Invalid",
    invalid_date: "Invalid Date",
    is_deleted:"Deleted",
    is_admin: "Admin",
    item_no: "Item No.",
    latitude: "Latitude",
    longitude: "Longitude",
    last_approval_by: "Last Approval By",
    last_approval_date: "Last Approval Date",
    level: "Level",
    license_no: "License No.",
    ln_do_third_party: "LN DO 3rd Party",
    ln_so_item_no: "LN SO Item No.",
    ln_so_no: "LN SO No.",
    ln_sto_item_no: "LN STO Item No.",
    ln_sto_no: "LN STO No.",
    loading: "Loading",
    loading_dest_from:"Loading From",
    location1: "Location From",
    location2: "Location To",
    location: "Location",
    lock_wb: "Lock WB",
    lookup: "Lookup",
    lookup_group: "Lookup Group",
    lookup_info1: "Lookup Info1",
    lookup_info2: "Lookup Info2",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    mark_complete: "Mark Complete",
    mark_deleted: "Mark Deleted",
    material: "Material",
    material_code: "Material Code",
    material_conversion: "Material Conversion",
    material_description:"Material Description",
    material_name: "Material",
    matrix: "Matrix",
    max_slot: "Max Slot",
    menu: "Menu",
    merge_order: "Merge Shipment",
    mode: "Mode",
    name1: "Name1",
    name2: "Name2",
    name3: "Name3",
    name4: "Name4",
    name:"Name",
    number_of_trips: "Number of Trips/UOM",
    numberoftripuom: "Trip UOM",
    numerator: "Numerator",
    order: "Order",
    order_item_no: "Order Item No.",
    order_no : "Order No.",
    order_os_qty: "O/S Order Qty",
    order_qty: "Order Qty",
    order_type: "Order Type",
    os_qty: "O/S Qty",
    partner_function: "Partner Function",
    password:"Password",
    payment_term: "Payment Term",
    percentage: "Percentage",
    per_value: "Per Value",
    phase: "Phase",
    phone: "Phone",
    pkp_no: "PKP No",
    pkp_validity: "PKP Validity",
    plant: "Plant",
    po_no: "PO No.",
    po_so_no: "PO SO No",
    pod: "POD (Proof of Delivery)",
    pod_date: "POD Date",
    pod_notes: "Notes",
    pod_upload_file: "Upload file(s)",
    port: "Port",
    postal_code: "Postal Code",
    product_category: "Product Category",
    product_category_itm: "Product Category (ITM)",
    product_category_sap: "SAP Product Category",
    product_group: "Product Group",
    progress_status: "Progress Status",
    pur_sales_org: "Pur/Sales Org.",
    purchase_org: "Purchase Org.",
    purchase_organization: "Purchase Organization",
    qty: "Qty",
    qty_kg: "Qty (KG)",
    quota: "Quota",
    quota_by: "Quota By",
    quota_per: "Quota Per",
    range_from_number: "Range From Number",
    range_to_number: "Range To Number",
    real_qty: "Real. Qty",
    reason: "Reason",
    reassign_do: "Reassign DO",
    receive_qty: "Receive Qty",
    ref_no: "Ref No.",
    ref_doc_no: "Doc. Ref No.",
    region: "Region",
    region_desc: "Region Desc",
    reject: "Reject",
    reject_order:"Reject Order",
    release_status : "Release Status",
    remaining_slot: "Remaining Slot",
    remarks: "Remarks",
    return_qty: "Return Qty",
    revert_qty: "Revert Qty",
    sales_district: "Sales District",
    sales_org: "Sales Org.",
    sales_organization: "Sales Organization",
    sap_freight_cost :"SAP Freight Cost",
    sap_item_no: "SAP Item No.",
    sap_no : "SAP No.",
    sap_order: "SAP Order",
    sap_order_no:"SAP Order No.",
    sap_order_os_qty: "O/S SAP Qty",
    save: "Save",
    shipment: "Shipment",
    shipment_item_no: "Shipment Item No.",
    shipment_no: "Shipment No.",
    shipment_qty: "Shipment Qty",
    shipment_tracking :"Shipment Tracking",
    shipment_type: "Shipment Type",
    slot_name: "Slot Name",
    so_do_no: "SO of DO No",
    status: "Status",
    status_from: "Status From",
    status_to: "Status To",
    sto_item_no: "STO Item No.",
    sto_no: "STO No.",
    sto_qty: "STO Qty",
    sto_uom: "STO UOM",
    street: "Street",
    stuffing_date: "Stuffing Date",
    sub_status_from: "Progress Status From",
    sub_status_to: "Progress Status To",
    system_num_trip: "No. Trips Based Capacity", //"System No. Trips",
    time_from: "Time From",
    time_to: "Time To",
    time_set: "Time Set",
    use_day: "Use Day",
    day: "Days",
    use_hour: "Use Hour",
    hours: "Hours",
    tolerance: "Tolerance",
    total_real_qty: "Total Real. Qty",
    transporter_status: "Transporter Status",
    transfer_type: "Transfer Type",
    transport_type: "Transport Type",
    transporter: "Transporter",
    transporter_notes: "Transporter Notes",
    transporter_quota: "Transporter Quota",
    truck:"Truck",
    truck_type: "Truck Type",
    type: "Type",
    upload_file: "Upload File",
    upload_transporter: "Upload Transporter Data",
    unmark_complete: "Unmark Complete",
    uom: "UOM",
    use_ad: "Use AD",
    user:"User",
    user_num_trip: "No. Trips by User", //User No. Trips",
    username:"Username",
    validity: "Validity",
    valid_date: "Valid Date SAP Order",
    valid_from: "Valid From",
    valid_to: "Valid To",
    vehicle_no: "Truck",
    version: "Version",
    vendor: "Vendor",
    vessel: "Vessel",
    view: "View",
    view_epod: "View ePOD",
    view_history: "Status History",
    view_order: "Order",
    view_orders: "View Orders",
    view_pod: "View/Edit POD",
    view_realization: "View Realization",
    view_sap_order: "View SAP Order",
    view_shipments: "View Shipments",
    warehouse: "Factory",
    warehouse_location: "Factory Location",
    wb_trans_type: "WB Trans Type",
    yes: "Yes",
    no: "No",

    version: "Version",
    version_date: "Version Date",
    changelog: "Changelog",
    version_active: "Active Version",
    truck_rental: "Truck Rental",
    exclude_approval: "Exclude Approval",

    
    pic_contract: "PIC Contract",
    pic_id: "PIC ID",
    pic_name: "PIC Name",
    number_trip: "Number of Trips",
    spo_item_no: "SPO Item No",
    without_price: "Without Price",
    header_text: "Header Text",
    pib_no: "PIB No.",
    fba_no: "FBA No.",
    contract_no: "Contract No.",
    contract_date: "Contract Date",
    with_contract: "With Contract",
    pic: "PIC",
    pic_location: "PIC Location",
    header_note: "Header Note",
    pricing_types: "Pricing Type",
    deadlines: "Deadlines",
    terms_of_delivery: "Terms of Delivery",
    shipping_instructions: "Shipping Instructions",
    payment_method: "Payment Method",
    warranties: "Warranties",
    penalty: "Penalty",
    guarranties: "Guarranties",
    contract_riders: "Contract Riders",
    other_contractual: "Other Contractual Stipulations",
    loading_destination: "Loading/Destination",
    vendor_memo: "Vendor Memo (General)",
    transport_mode: "Transport Mode/Vessel Name",
    cost_center: "Cost Center for Tolling",
    laytime: "Laytime",
    demurrage: "Demurrage",
    approval_remarks: "Approval Remarks",
    transfer_to: "Transfer To",
    doc_reference: "Doc Reference",
    contract_person: "Contract Person",
    address: "Address",
    po_change_revision: "PO Change Revision",
    plate_no: "Plate No/Container/Resi",
    per: "Per",
    ccy: "Ccy",
    delivery_date: "Delivery Date",
    plant_supplying: "Supplying Plant",
    plant_receiving: "Receiving Plant",
    tolerance_over: "Over. Tolerance",
    tolerance_under: "Under. Tolerance",
    tolerance_expeditor: "Expeditor Tole%",
    transaction_type: "Transaction Type",
    tracking_no: "Tracking No",
    mat_doc_year: "Material Doc. Year",
    grdaily: "ZGR Daily",
    continuous: "Continuous",
    valuation_type: "Valuation Type",
    previous_sto: "Previous STO",
    guarantees: "Guarantees",
    ipb_no: "IPB No.",
    ipb_item_no: "IPB Item No",
    item_text: "Item Text",
    material_po_text: "Material PO Text",
    delivery_text: "Delivery Text",
    ipb: "IPB",
    phase_date: "Phase Date",
    so_factory_no: "SO Factory No",
    so_factory_item_no: "Item",
    result: "Result",
    delivery_using_truck: "Delivery Using Truck",
    ln_type: "LN Type",
    incoterm_rule: "Incoterm Rule",
    language: "Language",
    salesperson: "Salesperson",
    telephone: "Telephone",
    your_reference: "Your Reference",
    our_reference: "Our Reference",
    communication: "Communication",
    zfrcost_no: "ZFRCost No",
    pod_requirement: "POD Control",
    all_document_type: "All Document Type",
    appointment_requirement: "Appointment Control",
    active: "Active",
    all_order_type: "All Order Type",
    sto_spo_per_shipment: "STO/SPO Per Shipment",
    plant_destination: "Plant Destination",
    factory_destination: "Factory Destination",
    langsir_type: "Langsir Type",
    show_info: "Show Info",
    hide_info: "Hide Info",
    report_date: "Report Date",
    registration_in_date: "Registration In",
    registration_out_date: "Registration Out",
    frc_term: "Terms of FRC",
    service: "Service",
    service_type: "Service Type",
    service_category: "Service Category",
    adjustment_lot: "Adjustment Lot",
    required_spr: "Required SPR",
    same_uom: "Same UOM",
    quantity_term: "Quantity Terms",
    spo_no: "SPO No.",
    purchase_group: "Purchase Group",
    edit_assign_transporter: "Edit Assign Transporter",
    sto: "STO",
    spo: "SPO",
    filter_by: "Filter By",
    version: "Version",
    version_date: "Version Date",
    changelog: "Changelog",
    version_active: "Active Version",
    truck_rental: "Truck Rental",
    exclude_approval: "Exclude Approval",
    pic_contract: "PIC Contract",
    pic_id: "PIC ID",
    pic_name: "PIC Name",
    number_trip: "Number of Trips",
    spo_item_no: "SPO Item No",
    without_price: "Without Price",
    header_text: "Header Text",
    pib_no: "PIB No.",
    fba_no: "FBA No.",
    contract_no: "Contract No.",
    contract_date: "Contract Date",
    with_contract: "With Contract",
    pic: "PIC",
    pic_location: "PIC Location",
    header_note: "Header Note",
    pricing_types: "Pricing Type",
    deadlines: "Deadlines",
    terms_of_delivery: "Terms of Delivery",
    shipping_instructions: "Shipping Instructions",
    payment_method: "Payment Method",
    warranties: "Warranties",
    penalty: "Penalty",
    guarranties: "Guarranties",
    contract_riders: "Contract Riders",
    other_contractual: "Other Contractual Stipulations",
    loading_destination: "Loading/Destination",
    vendor_memo: "Vendor Memo (General)",
    transport_mode: "Transport Mode/Vessel Name",
    cost_center: "Cost Center for Tolling",
    laytime: "Laytime",
    demurrage: "Demurrage",
    approval_remarks: "Approval Remarks",
    transfer_to: "Transfer To",
    doc_reference: "Doc Reference",
    contract_person: "Contract Person",
    address: "Address",
    po_change_revision: "PO Change Revision",
    plate_no: "Plate No/Container/Resi",
    per: "Per",
    ccy: "Ccy",
    delivery_date: "Delivery Date",
    plant_supplying: "Supplying Plant",
    plant_receiving: "Receiving Plant",
    tolerance_over: "Over. Tolerance",
    tolerance_under: "Under. Tolerance",
    tolerance_expeditor: "Expeditor Tole%",
    transaction_type: "Transaction Type",
    tracking_no: "Tracking No",
    mat_doc_year: "Material Doc. Year",
    zgrdaily: "ZGR Daily",
    continuous: "Continuous",
    valuation_type: "Valuation Type",
    previous_sto: "Previous STO",
    guarantees: "Guarantees",
    ipb_no: "IPB No.",
    ipb_item_no: "IPB Item No",
    item_text: "Item Text",
    material_po_text: "Material PO Text",
    delivery_text: "Delivery Text",
    ipb: "IPB",
    phase_date: "Phase Date",
    so_factory_no: "SO Factory No",
    so_factory_item_no: "Item",
    result: "Result",
    delivery_using_truck: "Delivery Using Truck",
    ln_type: "LN Type",
    incoterm_rule: "Incoterm Rule",
    language: "Language",
    salesperson: "Salesperson",
    telephone: "Telephone",
    your_reference: "Your Reference",
    our_reference: "Our Reference",
    communication: "Communication",
    zfrcost_no: "ZFRCost No",
    sto_type: "STO Type",
    spo_type: "SPO Type",
    ipb_no: "IPB No.",
    filter_order_ipb: "Order",
    spo_adjustment: "SPO Adjustment",
    spo_adjustment_no: "SPO Adjustment No.",
    spr_no: "SPR No.",
    spr_item_no: "SPR Item No.",
    result_data_sap: "Result",
    service_no: "Service No.",
    short_text: "Short Text",
    gross_price: "Gross Price",
    service_code: "Service Code",
    order_create_date: "Order Create Date",
    shipment_create_date: "Shipment Create Date",
    wb_ref_no: "WB Ref No.",
    wb_report_date: "WB Report Date",
    delivery_item_no: "Delivery Item No.",
    services: "Services",
    ref_spo: "Ref SPO No.",
    ref_spo_item: "Ref SPO Item",
    material_info: "Material Info",
    do_no: "DO No.",
    po_so_factory: "PO/SO Factory",
    po_so_contract_item_no: "PO/SO/Contract Item No",
    condition_type_header: "Condition Type Header",
    approval_status: "Approval Status",

    freight_cost_from: "Freight Cost Original",
    num_trip_to: "No Of Trips by User",
    freight_total_cost_user_not_to: "Freight Total Cost Revised",
    freight_cost_to: "Freight Cost Revised",
    freight_total_cost_user_not_from: "Freight Total Cost Original",
    freight_different_per_uom: "Different Per UOM",
    freight_different_percentage: "Percentage Different",
    freight_different_total: "Total Different",

    service_adjustment: "Service Code",
    qty_adjustment: "Amount Adjustment",
    uom_adjustment: "UOM Adjustment",
    gross_price_adjustment: "Gross Price Adjustment",
    per_adjustment: "Per UOM Service",
    condition_type_oa: "Condition Type OA STO",
    per_oa: "Per UOM",
    uom_oa: "UOM STO",

    vat_regulation: "VAT Regulation",
    filter: "Filter",

    kb: "KB",
    facility: "Facility",
    withdraw_shipment: "Withdraw Item",
    freight_approval_reason: "Freight Approval Reason",

    status_sto: "Status STO",
    status_spo: "Status SPO",
    locked: "Locked",
    appointment_slot: "Appointment Slot",
    change_reason: "Change Reason",
    gross_weight: "Gross Weight",

    so_do_item_no: "SO of DO Item No",
    so_do_item_no: "SO of DO Item No",
    container_no: "Container No",
    deletion_flag: "Deletion Flag",

    trip_type: "Trip Type",
    route_no: "Route No",
    tender_no: "Tender No (ZSLIP)",
    include_insurance: "Include Insurance",
    multiple_handling: "Multiple Handling",

    route: "Route No",
    multiple_route: "Multiple Route",
    loading_point: "Loading Point",
    unloading_point: "Unloading Point",
    route_description: "Route Description",
    route_no: "Route No.",

    alert:{
        require_loading: "Loading is required",
        require_destination: "Destination is required",
        require_charge_oa_company: "Charge OA Company is required",
        require_freight_date: "Freight Date is required",
        require_stuffing_date: "Stuffing Date is required",
        require_qty_assign_driver: "Cannot assign driver without quantity",
        require_driver_assign_driver: "Driver is required",
        require_license_assign_driver: "License No. is required",
        require_vehicle_assign_driver: "Truck is required",
        require_transporter: "Transporter is required",
        require_reason: "Reason is required",
        require_name: "Name is required",
        require_license_no: "License No. is required",
        require_address: "Address is required",
        require_date_of_birth: "Date of Birth is required",
        require_shipment_no: "Shipment No. is required",
        require_driver: "At least 1(one) or more driver(s) required",
        require_slot: "Slot is required",
        require_remarks: "Remarks is required",

        require_wb_report_date: "WB Report Date is required",

        require_distribution: "Distribution is required",
        require_commodity_group: "Commodity group is required",
        require_company: "Company is required",
        require_document_date: "Document Date is required",
        require_order_type: "Order Type is required",
        require_document_type: "Document Type is required"
    },
    message:{
        approval_confirmation: "Are you sure? These selected document(s) will be ",
        transporter_action_confirmation_accept: "Are you sure to accept these order(s)?",
        transporter_action_confirmation_reject: "Are you sure to reject these order(s)?",
        sap_filter_authorization: "The colored rows indicates that you do not have authorization to save",
        sto_change_without_price: "Are you sure to change Without Price flag? Details or Conditions will reset!",
        sto_refresh_order: "Are you sure to refresh the STO document? Details will be changed according to current Order data"
    }
}

export default message;